import NextShowItem from "./NextShowItem.jsx";
import { isEmpty, map } from 'lodash';
const LOCALE = 'de';
import { toTime } from '/utils';
import Link from 'next/link';
import ViewButton from "./buttons/ViewButton";
import {DateTime} from "luxon";
import {SvgEventTicketSm} from "/components/shared/SvgIcons";


export default function VODItem({shows = []}) {
    if (isEmpty(shows)) {
        return null;
    }
    return (
        <div className=''>
          <h1 className="mb-text-lg xl:text-xl text-gray-dark">
            Video On Demand
          </h1>
          {map(shows, show => {
              let url = '';
              if (show.event) {
                  url =  `/theater-details/${show.event?.slug}`;
              }
              let title = show.event?.title;
              return (
                  <div className="flex flex-row pb-2 mb-2 px-4 pt-4">
                    <div className="flex-1">
                      <div className="flex flex-1 flex-col lg:flex-row flex-wrap text-sm xl:text-base justify-start py-1 flex-start">
                        <div className="flex-1 flex flex-row items-start">
                          <div>
                            <div className="leading-6 xl:leading-8 font-cooper-hewitt-bold max-w-[50vw] md:max-w-auto capitalize truncate">
                              {url ? (
                                  <Link href={url} >
                                    <a>
                                      {title}
                                    </a>
                                  </Link>
                              ) : title}
                            </div>
                            <div className="-mt-1 text-sm max-w-70">Diese Vorstellung ist als Video on Demand verfügbar und kann jederzeit abgerufen werden.</div>
                          </div>
                        </div>
                        <div>
                          <ViewButton href={`/tickets/${show.slug}`} className='px-2 2xl:px-4 pt-2 pb-1 h-7 2xl:ml-12'
                                      icon={<div className='mr-2 mb-1'>{SvgEventTicketSm()}</div>}>
                            tickets
                          </ViewButton>
                        </div>
                      </div>
                    </div>
                  </div>
              );
          })}
        </div>
    )
}
